import { Typography } from "@material-ui/core"
import FormikCheckbox from "common/bit/form/FormikCheckbox"
import styled from "styled-components"
import CheckBoxIcon from "./CheckBoxIcon"
import CheckBoxSelectedIcon from "./CheckBoxSelectedIcon"

const StyledLableText = styled(Typography).attrs({ variant: "caption" })`
  text-align: start;
  line-height: 1.3;
  color: ${(p) => p.theme.colors.black};
  a {
    font-size: 12px;
    text-decoration: underline;
  }
`
type FormCheckBoxWithLableProps = {
  name: string
  label: string
}

const FormCheckBoxWithLable = ({ name, label }: FormCheckBoxWithLableProps) => {
  return (
    <>
      <FormikCheckbox
        name={name}
        normalIcon={<CheckBoxIcon />}
        checkedIcon={<CheckBoxSelectedIcon />}
        labelText={label}
      >
        <StyledLableText>{label}</StyledLableText>
      </FormikCheckbox>
    </>
  )
}

export default FormCheckBoxWithLable
